import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import { ButtonToggle } from '@motorway/mw-highway-code/pre-alpha';

import stylesFilter from 'Components/VehicleList/filters/Filters.module.scss';
import { applyCypressData, filterValue } from 'Utilities/helpers';

export const handleToggleCheckbox = ({ callback, selected, value }) => {
	if (selected.includes(value)) {
		const remaining = filterValue(selected, value);
		const nextState = remaining.length ? filterValue(remaining, 'all') : ['all'];

		callback(nextState);

		return isEqual(nextState, ['all']) ? [] : nextState;
	}
	if (value === 'all') {
		callback([value]);

		return [];
	}
	selected.push(value);
	const nextState = filterValue(selected, 'all');

	callback(nextState);

	return nextState;
};

const CheckboxGroup = ({ checked = ['all'], columns, name, onClick, options, tabIndex }) => {
	const [selected, setSelected] = useState(checked);
	useEffect(() => {
		setSelected(isEmpty(checked) ? ['all'] : checked);
	}, [checked]);

	return (
		<div className={stylesFilter.buttonSwitcher}>
			<div className={stylesFilter.buttonScroller}>
				<div
					className={cx(stylesFilter.buttonContent, {
						[stylesFilter.twoColumns]: columns === 2,
					})}
					data-length={options.length}
				>
					{options.map((option) => {
						const { label, value } = option;
						const id = `${value}-${name}`;
						const isChecked = selected.includes(value);
						const onClickOption = () => {
							const nextState = handleToggleCheckbox({ callback: setSelected, selected, value });
							const nextIsChecked = !isChecked;
							onClick(value, nextIsChecked, nextState);

							if (!nextIsChecked) {
								document.activeElement.blur();
							}
						};
						return (
							<ButtonToggle
								key={id}
								{...applyCypressData(`${id}Button`)}
								fullWidth
								id={id}
								label={label}
								onClick={onClickOption}
								selected={isChecked}
								tabIndex={tabIndex}
								type="button"
								variant="secondary"
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
};

CheckboxGroup.defaultProps = {
	checked: ['all'],
	columns: 3,
	tabIndex: 0,
};

CheckboxGroup.propTypes = {
	checked: PropTypes.arrayOf(PropTypes.string),
	columns: PropTypes.number,
	name: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.string,
		}),
	).isRequired,
	tabIndex: PropTypes.number,
};

export default CheckboxGroup;
